import { t } from '@lingui/macro'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isToday from 'dayjs/plugin/isToday'
import isTomorrow from 'dayjs/plugin/isTomorrow'
import isYesterday from 'dayjs/plugin/isYesterday'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

import DATETIME from '../../../../constants/dateTime.constants'

export default function getDateText(startAt: number, isVideo?: boolean) {
  dayjs.extend(relativeTime)
  dayjs.extend(localizedFormat)
  dayjs.extend(isToday)
  dayjs.extend(isTomorrow)
  dayjs.extend(isYesterday)
  dayjs.extend(isSameOrAfter)

  const todaysDate = dayjs(new Date()).unix()

  const isCurrentOrUpcomingYear = dayjs
    .unix(startAt)
    .isSameOrAfter(dayjs(), 'year')

  const getDateString = () => {
    if (isVideo) {
      return isCurrentOrUpcomingYear
        ? dayjs.unix(startAt).format('D MMM')
        : dayjs.unix(startAt).format('D MMM YYYY')
    }
    if (startAt < todaysDate) {
      return dayjs
        .unix(startAt)
        .format(isCurrentOrUpcomingYear ? 'D MMM HH:mm' : 'DD MMM YYYY')
    }
    if (dayjs.unix(startAt).isToday()) {
      return `${t`Today`} ${dayjs.unix(startAt).format('HH:mm')}`
    }
    if (dayjs.unix(startAt).isTomorrow()) {
      return `${t`Tomorrow`} ${dayjs.unix(startAt).format('HH:mm')}`
    }

    if (startAt < todaysDate + DATETIME.SIX_DAYS) {
      return dayjs.unix(startAt).format('ddd HH:mm')
    }
    return dayjs.unix(startAt).format('D MMM HH:mm')
  }
  return { getDateString, todaysDate }
}
